(() => {
  function checkValidity(select) {
    if (select && select.checkValidity) {
      if (select.checkValidity()) {
        select.removeAttribute('aria-invalid');
        const previousDescribedBy = select.getAttribute('data-aria-describedby');
        if (previousDescribedBy) {
          select.setAttribute('aria-describedby', previousDescribedBy);
        } else {
          select.removeAttribute('aria-describedby');
        }
      } else {
        select.setAttribute('aria-invalid', 'true');
        const previousDescribedBy = select.getAttribute('aria-describedby') || '';
        if (previousDescribedBy && !select.getAttribute('data-aria-describedby')) {
          select.setAttribute('data-aria-describedby', previousDescribedBy);
        }
        select.setAttribute('aria-describedby', `${previousDescribedBy} ${window.swinger.a11y.createDescription(select.validationMessage)}`);
      }
    }
  }

  function checkDisplayValidity(select, wrapper) {
    if (select && select.checkValidity) {
      if (select.checkValidity()) {
        wrapper.removeAttribute('data-validation-message');
      } else {
        wrapper.setAttribute('data-validation-message', select.validationMessage);
      }
    }
  }

  let searchTimeout;

  const previousValues = window.WeakMap ? new WeakMap() : new Map();
  const listMap = window.WeakMap ? new WeakMap() : new Map();
  const timerMap = window.WeakMap ? new WeakMap() : new Map();
  const notifyATTimers = window.WeakMap ? new WeakMap() : new Map();

  function search(input) {
    window.clearTimeout(searchTimeout);
    window.clearTimeout(timerMap.get(input));
    searchTimeout = window.setTimeout(() => {
      const searchTerm = input.textContent.trim().toLowerCase();
      const wrapper = input.closest('.swinger-select');
      const hiddenInput = window.swinger.$('.swinger-select__multiple-hidden-input', wrapper)[0];
      const firstChild = window.swinger.$('.swinger-select__multiple-list', wrapper)[0];
      const list = listMap.get(input) || firstChild;
      const listClone = list.cloneNode();
      const listParent = firstChild.parentElement;

      input.setAttribute('aria-activedescendant', '');

      if (!list.children.length) {
        return;
      }

      listMap.set(input, list);
      if (firstChild && listParent.contains(firstChild)) {
        listParent.removeChild(firstChild);
      }

      const selectedValues = [].slice.call(hiddenInput.options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      const filteredItems = [];
      const itemData = [];
      const itemTexts = [];
      for (let i = 0, length = list.children.length; i < length; i += 1) {
        const item = list.children[i];
        const value = item.getAttribute('data-value');
        const text = item.textContent.trim().toLowerCase();
        const isSelected = selectedValues.indexOf(value) !== -1;
        let matches = false;

        itemData[i] = {
          value,
          text,
          isSelected,
        };
        itemTexts[i] = text;

        item.removeAttribute('id');
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        item.classList[isSelected ? 'add' : 'remove']('swinger-select__multiple-listitem--selected');

        if (searchTerm) {
          const itemTerms = text.split(' ');
          matches = itemTerms.find((term) => term.startsWith(searchTerm));
          item.style.display = matches ? '' : 'none';
          if (matches && !isSelected) {
            filteredItems.push(item);

            if (filteredItems.length < 30) {
              const itemClone = item.cloneNode(true);
              listClone.appendChild(itemClone);
            }
          }
        } else {
          item.style.display = '';
          filteredItems.push(item);

          if (filteredItems.length < 30) {
            const itemClone = item.cloneNode(true);
            listClone.appendChild(itemClone);
          }
        }
      }

      if (searchTerm && !filteredItems.length && itemTexts.join('').indexOf(searchTerm) > -1) {
        for (let i = 0, length = list.children.length; i < length; i += 1) {
          const item = list.children[i];
          const { text, isSelected } = itemData[i];
          let matches = false;

          if (searchTerm) {
            matches = text.indexOf(searchTerm) !== -1;
            item.style.display = matches ? '' : 'none';
            if (matches && !isSelected) {
              filteredItems.push(item);
            }
          }
        }
      }

      if (!filteredItems.length) {
        window.swinger.i18n()
          .then((i18n) => {
            list.setAttribute('data-no-results', i18n('ui.select.no-results'));
          })
          .catch(console.info);
      } else {
        list.removeAttribute('data-no-results');
        list.scrollTop = 0;
      }

      window.clearTimeout(notifyATTimers.get(list));
      notifyATTimers.set(list, window.setTimeout(() => {
        window.swinger.i18n()
          .then((i18n) => {
            window.swinger.a11y.notify(i18n('ui.shared.matching-options', {
              totalCount: filteredItems.length,
            }));
          })
          .catch(console.info);
      }, 1000));

      listParent.appendChild(listClone);
      timerMap.set(input, window.setTimeout(() => {
        const firstChild = window.swinger.$('.swinger-select__multiple-list', wrapper)[0];
        if (firstChild) {
          if (firstChild !== list) {
            listParent.replaceChild(list, firstChild);
          }
        } else {
          listParent.appendChild(list);
        }
      }, 600));
    }, 300);
  }

  function renderSelectedTags(input, noFocus) {
    const range = document.createRange();
    const sel = window.getSelection();
    const wrapper = input.closest('.swinger-select');
    const list = window.swinger.$('.swinger-select__multiple-list', wrapper)[0];
    const inputContainer = window.swinger.$('.swinger-select__multiple-input', wrapper)[0];
    const hiddenInput = window.swinger.$('.swinger-select__multiple-hidden-input', wrapper)[0];
    const selectedOptions = [].slice.call(hiddenInput.options)
      .filter((option) => option.selected);
    const tags = window.swinger.$('.swinger-select__multiple-tag', inputContainer);

    tags.forEach((tag) => {
      if (selectedOptions.indexOf(tag.getAttribute('data-value')) > -1) {
        return;
      }

      inputContainer.removeChild(tag);
    });

    if (list) {
      const listItems = window.swinger.$('[data-value]', list);
      if (listItems) {
        listItems.forEach((listItem) => {
          listItem.setAttribute('aria-selected', 'false');
          listItem.classList.remove('swinger-select__multiple-listitem--selected');
        });
      }
    }

    selectedOptions.forEach((option) => {
      if (list) {
        const listItem = window.swinger.$(`[data-value="${option.value}"]`, list)[0];

        if (listItem) {
          listItem.setAttribute('aria-selected', 'true');
          listItem.classList.add('swinger-select__multiple-listitem--selected');
        }
      }

      if (window.swinger.$(`[data-value="${option.value}"]`, inputContainer)[0]) {
        return;
      }

      const tag = document.createElement('b');

      tag.className = 'swinger-select__multiple-tag';
      tag.setAttribute('data-value', option.value);
      tag.innerHTML = `${option.label.replace(/\s\([\d+.,]+\)$/, '')}<button type="button" class="swinger-select__multiple-tag-remove">Entfernen</button>`;

      inputContainer.insertBefore(tag, input);
    });

    if (wrapper.hasAttribute('data-max')) {
      const max = Number(wrapper.getAttribute('data-max'));

      if (selectedOptions.length >= max) {
        wrapper.classList.add('swinger-select--maxed-out');
        return;
      }
    }

    wrapper.classList.remove('swinger-select--maxed-out');
    input.textContent = '';
    previousValues.set(input, '');
    search(input);

    if (noFocus) {
      return;
    }

    input.focus();

    if (input.textContent) {
      range.setStart(input.childNodes[0], input.textContent.length);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  function changeOption(input, value, selected) {
    const noFocus = document.activeElement !== input;
    const wrapper = input.closest('.swinger-select');
    // const editor = window.swinger.$('..swinger-select__multiple-editor', wrapper)[0];
    const hiddenInput = window.swinger.$('.swinger-select__multiple-hidden-input', wrapper)[0];
    const option = window.swinger.$(`option[value="${value}"]`, hiddenInput)[0];

    if (option) {
      if (selected) {
        const firstUnselected = window.swinger.$('option:not([selected])', hiddenInput)[0];

        hiddenInput.insertBefore(option, firstUnselected);
        option.setAttribute('selected', 'selected');
      } else {
        option.setAttribute('selected', 'selected');
        option.removeAttribute('selected');
      }

      option.selected = selected;
    }

    window.swinger.eventHub.trigger(hiddenInput, 'input');
    window.swinger.eventHub.trigger(hiddenInput, 'change');

    if (input.closest('.swinger-facetted-search')) {
      return;
    }

    renderSelectedTags(input, noFocus);
  }

  function removeLastTag(input) {
    const wrapper = input.closest('.swinger-select');
    const tags = window.swinger.$('.swinger-select__multiple-tag', wrapper);
    const lastTag = tags.pop();
    const value = lastTag && lastTag.getAttribute('data-value');

    changeOption(input, value, false);
  }

  window.swinger.eventHub.register('click', '.swinger-select__multiple-tag-remove', (e) => {
    const tag = window.swinger.eventHub.getTarget(e).closest('.swinger-select__multiple-tag');
    const wrapper = tag.closest('.swinger-select');
    const input = window.swinger.$('.swinger-select__multiple-editor', wrapper)[0];
    const value = tag.getAttribute('data-value');

    changeOption(input, value, false);

    e.preventDefault();
  });

  let lastMouseDownElem;

  window.swinger.eventHub.register('mousedown', '.swinger-select__select, .swinger-select__multiple-editor', (e) => {
    lastMouseDownElem = window.swinger.eventHub.getTarget(e);
  });

  window.swinger.eventHub.register('focus', '.swinger-select__select, .swinger-select__multiple-editor', (e) => {
    console.log(e.type);
    const input = window.swinger.eventHub.getTarget(e);
    const wrapper = input.closest('.swinger-select');
    const button = window.swinger.$('.swinger-select__multiple-toggle', wrapper)[0];
    const list = window.swinger.$('.swinger-select__multiple-list', wrapper)[0];

    wrapper.classList.add('swinger-select--was-touched');
    wrapper.classList.add('swinger-select--is-focused');

    if (lastMouseDownElem !== input) {
      return;
    }

    input.setAttribute('aria-expanded', 'true');

    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }

    if (list) {
      list.setAttribute('aria-hidden', 'false');
    }
  });

  window.swinger.eventHub.register('blur', '.swinger-select__select, .swinger-select__multiple-editor', (e) => {
    const wrapper = window.swinger.eventHub.getTarget(e).closest('.swinger-select');
    const select = window.swinger.$('select', wrapper)[0];

    wrapper.classList.remove('swinger-select--is-focused');

    checkDisplayValidity(select, wrapper);
  });

  window.swinger.eventHub.register('change', '.swinger-select__select, .swinger-select__multiple-hidden-input', (e) => {
    const wrapper = window.swinger.eventHub.getTarget(e).closest('.swinger-select');
    const select = window.swinger.$('select', wrapper)[0];
    const input = window.swinger.$('.swinger-select__multiple-editor', wrapper)[0];
    if (input) {
      renderSelectedTags(input, true);
    }

    checkValidity(select);
  });

  window.swinger.eventHub.register('keyup', '.swinger-select__multiple-editor', (e) => {
    const input = window.swinger.eventHub.getTarget(e);
    const previousValue = previousValues.get(input);

    switch (e.key) {
      default:
        if (input.textContent === previousValue) {
          return;
        }
        previousValues.set(input, input.textContent);
        break;

      case 'Up':
      case 'ArrowUp':
      case 'Down':
      case 'ArrowDown':
      case 'Left':
      case 'ArrowLeft':
      case 'Right':
      case 'ArrowRight':
      case 'Backspace':
      case 'Enter':
      case 'Escape':
        return;
    }

    window.requestAnimationFrame(() => {
      const wrapper = input.closest('.swinger-select');
      const button = window.swinger.$('.swinger-select__multiple-toggle', wrapper)[0];
      const targetId = button.getAttribute('aria-controls');
      const target = window.swinger.$(`#${targetId}`, wrapper)[0];

      try {
        input.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
      } catch (e) {
      // noop
      }
      search(input);
    });
  });

  window.swinger.eventHub.register('keydown', document, (e) => {
    if (e.key !== 'Escape' && e.key !== 'Esc') {
      return;
    }

    if (e.target.closest('.swinger-select--multiple')) {
      const wrapper = window.swinger.eventHub.getTarget(e).closest('.swinger-select');
      const input = window.swinger.$('.swinger-select__multiple-editor', wrapper)[0];

      input.textContent = '';
      previousValues.set(input, '');
      input.focus();
    }
  }, true);
  // End

  const addFreeFormEntry = (input) => {
    const value = input.textContent.trim();

    if (!value) {
      return;
    }

    const wrapper = input.closest('.swinger-select');
    const hiddenInput = window.swinger.$('.swinger-select__multiple-hidden-input', wrapper)[0];
    const existingOption = hiddenInput.querySelector(`option[value="${value}"]`);

    if (existingOption) {
      return;
    }

    const list = window.swinger.$('.swinger-select__multiple-list', wrapper)[0];
    const items = [].slice.call(list.children);
    const option = document.createElement('option');
    const item = document.createElement('li');
    const insertBeforeItemIndex = items.findIndex((item) => value.localeCompare(item.textContent, 'en', { numeric: true }) === -1);
    const insertBeforeItem = items[insertBeforeItemIndex];

    option.setAttribute('value', value);
    option.textContent = value;
    hiddenInput.appendChild(option);

    window.setTimeout(() => {
      item.className = 'swinger-select__multiple-listitem';
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'true');
      item.setAttribute('tabindex', '0');
      item.setAttribute('title', value);
      item.setAttribute('data-value', value);
      item.textContent = value;
      list.insertBefore(item, insertBeforeItem);

      window.setTimeout(() => {
        changeOption(input, value, true);
      });
    });
  };

  window.swinger.eventHub.register('mousedown', 'form button[type="submit"]', (e) => {
    const form = window.swinger.eventHub.getTarget(e).closest('form');
    const wrappers = window.swinger.$('.swinger-select--freeform', form);

    if (!wrappers.length) {
      return;
    }

    wrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('.swinger-select__multiple-editor');
      const value = input.textContent.trim();

      if (!value) {
        return;
      }

      const hiddenInput = window.swinger.$('.swinger-select__multiple-hidden-input', wrapper)[0];
      const existingOption = hiddenInput.querySelector(`option[value="${value}"]`);

      if (existingOption) {
        return;
      }

      const option = document.createElement('option');

      option.setAttribute('value', value);
      option.setAttribute('selected', 'selected');
      option.textContent = value;
      hiddenInput.appendChild(option);
    });
  });

  window.swinger.eventHub.register('swinger-widget:rendered', '.swinger-widget', (e) => {
    const widget = window.swinger.eventHub.getTarget(e);

    window.clearTimeout(searchTimeout);

    window.swinger.$('.swinger-select__multiple-editor', widget).forEach((input) => {
      window.clearTimeout(timerMap.get(input));
    });
  });

  window.swinger.eventHub.register('keydown', '.swinger-select__multiple-editor', (e) => {
    const input = window.swinger.eventHub.getTarget(e);
    const wrapper = input.closest('.swinger-select');
    const button = window.swinger.$('.swinger-select__multiple-toggle', wrapper)[0];
    const lists = window.swinger.$('.swinger-select__multiple-list', wrapper);

    if (!lists.length) {
      return;
    }

    const list = lists[0];
    const items = [].slice.call(list.children);
    const filteredItems = items.filter((item) => item.style.display !== 'none');

    switch (e.key) {
      default:
        break;

      case 'Enter':
        if (filteredItems.length) {
          window.setTimeout(() => {
            changeOption(input, filteredItems[0].getAttribute('data-value'), true);
          });
        } else if (wrapper.matches('.swinger-select--freeform')) {
          addFreeFormEntry(input);
        }

        input.textContent = '';
        previousValues.set(input, '');
        search(input);
        e.preventDefault();
        break;

      case 'Down':
      case 'ArrowDown':
        button.setAttribute('aria-expanded', 'true');
        list.setAttribute('aria-hidden', 'false');
        break;

      case 'Backspace':
        search(input);

        if (!input.textContent) {
          removeLastTag(input);
        }
        break;
    }
  });

  /* The following allows for cursor navigation in between all currently visible menu items */
  window.swinger.navigationHelper.enableArrowNav('.swinger-select--multiple', '.swinger-select__label, .swinger-select__multiple-toggle, .swinger-select__multiple-tag-remove');

  window.swinger.eventHub.register('click keydown', '.swinger-select__multiple-listitem', (e) => {
    if (['click', 'mousedown', 'keydown'].indexOf(e.type) === -1 || (e.type === 'keydown' && e.key !== 'Enter' && e.key !== 'Space')) {
      return;
    }

    const listitem = window.swinger.eventHub.getTarget(e);
    const wrapper = listitem.closest('.swinger-select');
    const input = window.swinger.$('.swinger-select__multiple-editor', wrapper)[0];

    window.setTimeout(() => {
      changeOption(input, listitem.getAttribute('data-value'), listitem.getAttribute('aria-selected') !== 'true');
    });

    e.preventDefault();
    e.stopImmediatePropagation();
  });

  window.swinger.eventHub.register('reset', 'form', (e) => {
    const form = window.swinger.eventHub.getTarget(e);

    window.swinger.$('.swinger-select__multiple-editor', form).forEach((input) => {
      renderSelectedTags(input, true);
    });
  });

  window.swinger.observer.initialize('.swinger-select__multiple-editor', (input) => {
    search(input);
    renderSelectedTags(input, true);
  }, false);
})();
